module.exports = __webpack_public_path__ + "img/c06_unittechbiremechampion_Normal_ua.77f66151.webp";